export const DISMISSAL_STATES = {
  DISMISSED: 'dismissed',
  ALL: 'all',
};
